import type { Product, ProductVariant, StoreInventory } from "@cliqsuite/db/schemas";
import { formatMoney } from "../lib/format";

export function RetailVariantModal({ product, variants, inventory, currency, onPick, onClose }: {
  product: Product;
  variants: ProductVariant[];
  inventory: StoreInventory[];
  currency: { code: string; precision: 0 | 2 | 3 };
  onPick: (variant: ProductVariant) => void;
  onClose: () => void;
}) {
  const fmt = (v: number) => formatMoney(v, { currencyCode: currency.code, precision: currency.precision });
  return (
    <div className="pos-dim side" onClick={onClose}>
      <section role="dialog" aria-modal="true" aria-labelledby="variant-t" className="pos-dialog side" onClick={(event) => event.stopPropagation()}>
        <div className="pos-dialog-head">
          <h2 id="variant-t">
            {product.name}
            <small>Pick the one they're buying</small>
          </h2>
          <button className="pos-sq-btn big" onClick={onClose} aria-label="Close">
            <span className="ms" aria-hidden="true">close</span>
          </button>
        </div>
        <div className="pos-variants">
          {variants.map((variant) => {
            const stock = inventory.find((row) => row.variant_id === variant.id);
            const available = !!stock && !stock.is_out_of_stock && stock.quantity > 0;
            return (
              <button key={variant.id} type="button" disabled={!available} onClick={() => onPick(variant)}>
                <span>
                  <b>{variant.variant_label}</b>
                  <small className="num">
                    {variant.sku}, {available ? `${stock.quantity} in stock` : "sold out"}
                  </small>
                </span>
                <b className="num">{fmt(variant.price_override ?? product.base_price)}</b>
              </button>
            );
          })}
          {variants.length === 0 && <p className="pos-approve-wait">No variants are set up for this item.</p>}
        </div>
        <div className="pos-variants-hint">
          <span className="ms" aria-hidden="true">barcode_reader</span>
          Scanning the item's barcode adds the right one straight away.
        </div>
      </section>
    </div>
  );
}
